<script lang="ts">
  import { get } from 'svelte/store'
  import { fn } from '@packages/stores'
  import { Sign } from '@packages/ui'
  import { pageOptsStore } from '@packages/stores'
  import { configStore } from '../../../stores/config'
  import socketFn from '@lib/ws/socket-io'
  import { sdk } from '@packages/utils/lib/sdk/sdk'

  const { close } = get(fn)

  const handleSignTransaction = async () => {
    const { signature } = await sdk.sui.signPersonalMessage($pageOptsStore.message)
    socketFn.signDataAndEmitEvent($configStore.credenza.generalWssUrl, signature, $pageOptsStore.socketEventData)
    close()
  }
</script>

<Sign
  options={{
    title: 'Sign Transaction Request',
    description: 'Please sign the requested transaction.',
    onCancel: close,
    onConfirm: handleSignTransaction,
  }}
/>
